import { Flex, Text } from '@mantine/core';
import { formatPrice } from '@/lib/helpers';
import { TAgentService } from '@/models/agents';
import classes from './AgentServiceEntry.module.css';

export default function AgentServiceEntry({
  service,
  onClick,
}: {
  service: TAgentService;
  onClick?: () => void;
}) {
  return (
    <Flex
      justify={'space-between'}
      className={classes.entry}
      gap={'sm'}
      onClick={onClick}
      style={{ cursor: onClick ? 'pointer' : 'default' }}
      py={'0.2rem'}
    >
      <Text size="xs" td={'underline'}>
        {service.name}
      </Text>
      <Text size="xs">{formatPrice(service.cogs, service.currency)}</Text>
    </Flex>
  );
}
